<template>
  <EmptyState
    v-if="scenario === 'noApprovals'"
    icon="mdi-clipboard-text-outline"
    :title="$t('routines.approval.request_empty_state_title')"
    :message="
      canRequestApproval
        ? $t('routines.approval.request_empty_state_subtitle')
        : $t('routines.approval.empty_state_subtitle')
    "
    :buttonText="
      canRequestApproval ? $t('routines.approval.request_approval') : null
    "
    :buttonTestId="'routineApprovalEmptyState-button-requestApproval'"
    @click="$emit('requestApproval')"
  />

  <EmptyState
    v-else-if="scenario === 'inProgress'"
    icon="mdi-clock-outline"
    :title="$t('routines.approval.no_completed_state_title')"
    :message="$t('routines.approval.no_completed_state_subtitle')"
  />
</template>

<script>
import EmptyState from '@/components/EmptyState.vue'

export default {
  name: 'RoutineApprovalEmptyState',

  components: {
    EmptyState,
  },

  props: {
    canRequestApproval: {
      type: Boolean,
      default: false,
    },
    scenario: {
      type: String,
      required: true,
    },
  },
}
</script>
